import React, { useEffect, useState } from 'react';
import { Affix, Button, Card, Divider, message, Result, Row } from 'antd';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

// import '@ant-design/compatible/assets/index.css';


import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import Language from './tabs/Language';
import {
  getPoiByIdAction,
  getPoiCompleteByIdAction,
  savePoiAction,
} from '../../../actions/AppCms/PoiActions';
import { history } from '../../../utils/history';
// import PoiPdf from '../../../components/Pdf/PoiPdf';
import Authorized from '../../../components/Authorization/Authorized';
import AuditTrail from '../../../components/AuditTrail/AuditTrail';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const AddPoi = ({ match, form }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(); 

  const [finished, setFinished] = useState(false);
  // const [exportButtonClicked, setExportButtonClicked] = useState(false);
  const [itemId, setItemId] = useState(0);

  const { poi, cmsLanguageList } = useSelector(store => ({
    poi: store.poiReducer.poi,
    cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
  }));

  useEffect(() => {
    dispatch(getCmsLanguagesAction());
    const { id } = match.params;
    setItemId(id);

    if (id > 0) {
      dispatch(getPoiByIdAction(id));
    }
  }, []);

  const handleGoPois = () => {
    history.push('/pois');
  };

  const handleGoAddNew = () => {
    history.push('/add-Poi');
  };

  const handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        if (!err) {
          const content = [];
          cmsLanguageList.map(item => {
            content.push({
              title: fieldsValue['title-' + item.isoLanguage.code],
              subtitle: fieldsValue['subtitle-' + item.isoLanguage.code],
              description: fieldsValue['description-' + item.isoLanguage.code],
              audioList: fieldsValue['audioList-' + item.isoLanguage.code],
              language: item.isoLanguage.code,
              state:
                fieldsValue['state-' + item.isoLanguage.code] ||
                (item.defaultInMobileApp &&
                  fieldsValue['state-' + item.isoLanguage.code] === undefined)
                  ? 'PUBLISHED'
                  : 'INHERITED',
            });
            return null;
          });

          const values = {
            content,
            externalReference: fieldsValue.externalReference,
            imageList: fieldsValue.imageList,
            featuredImage: fieldsValue.featuredImage
              ? fieldsValue.featuredImage[0]
              : null,
            referenceImageList: fieldsValue.referenceImageList,
            videoFiles: fieldsValue.videoFiles || [],
            glbFiles:   fieldsValue.glbFiles   || [],
            group: {
              id: fieldsValue.group,
            },
            linkedItemIds: fieldsValue.linkedItemIds,
            beaconSensitivityRange: {
              min: fieldsValue.beaconSensitivityRange[0],
              max: fieldsValue.beaconSensitivityRange[1],
            },
            location: {
              location: fieldsValue.address,
              latitude: fieldsValue.latitude,
              longitude: fieldsValue.longitude,
            },
            youtubeLink: fieldsValue.youtubeLink,
          };



          if (itemId > 0) {
            dispatch(savePoiAction(values, itemId)).then(() => {
              message.success(t('appCms.poi.successfullySaved'));
              setFinished(true);
            });
          }
        }
      }
    });
  };

  const getReportData = (poiData, lang) => {
    const result =
      poiData &&
      poiData.data.content.filter(obj => {
        return obj.language === lang;
      });
    return result ? result[0] : result;
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 16 },
      lg: { span: 12 },
    },
  };

  return (
    (<CustomAddNewPageContent
      title={t('appCms.poi.updatePoi')}	
      subTitle={t('appCms.poi.pointOfInterest')}
      // exportButton={
      //   <Button type="primary" onClick={() => handleExport()}>
      //     Export PDF
      //   </Button>
      // }
    >
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Form {...formItemLayout} onSubmit={handleSubmit}>
          <Card
            title={t('appCms.general')}
            bordered={false}
            extra={
              <Affix offsetTop={10}>
                <Authorized asset="appcms" operation="write">
                  <Button type="primary" htmlType="submit">
                    {t('common.save')}
                  </Button>
                </Authorized>
              </Affix>
            }
          >
            <General form={form} reportData={poi} submit={handleSubmit} />
          </Card>
          {cmsLanguageList.map(item => (
            <Card
              key={item.isoLanguage.code}
              title={
                item.isoLanguage.code +
                (item.defaultInMobileApp ?   ` (${t('appCms.default')})` : '')
              }
            >
              <Language
                form={form}
                langCode={item.isoLanguage.code}
                reportData={getReportData(poi, item.isoLanguage.code)}
                defaultLang={item.defaultInMobileApp}
                submit={handleSubmit}
                language={item}
              />
            </Card>
          ))}
          {/*
            <Card title="EN" bordered={false}>
              <Language form={form} reportData={poi} />
            </Card>
            <Card title="MT" bordered={false}>
              <Language form={form} reportData={poi}  lang={item.isoLanguage.code}  />
            </Card> */}
          <Authorized asset="item" operation="write">
            <Divider />
            <Row type="flex" justify="center">
              <Button type="primary" htmlType="submit">
                {t('common.save')}
              </Button>
            </Row>
            <Divider />
            <AuditTrail objectId={itemId} objectType="point of interest" />
          </Authorized>
        </Form>)
      )}
      {finished && (
        <Result
          status="success"
          title={t('appCms.poi.successfullySaved')}
          // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
          extra={[
            <Button type="primary" key="console" onClick={handleGoPois}>
              {t('appCms.poi.goToPois')}
            </Button>,
            <Button key="buy" onClick={handleGoAddNew}>
              {t('appCms.poi.addPoi')}
            </Button>,
          ]}
        />
      )}
      {/* {exportButtonClicked && (
          <PoiPdf
            report={poiComplete}
            callback={exportCallBack}
          />
        )} */}
    </CustomAddNewPageContent>)
  );
};

AddPoi.propTypes = {
  form: PropTypes.object,
  savePoiAction: PropTypes.func,
  getPoiByIdAction: PropTypes.func,
  match: PropTypes.object,
  poi: PropTypes.object,
  getPoiCompleteByIdAction: PropTypes.func,
};

const WrappedPoiForm = Form.create({
  name: 'WrappedPoi',
})(AddPoi);

function mapStateToProps() {
  return {};
}

const WrappedAddPoi = connect(mapStateToProps, {
  savePoiAction,
  getPoiByIdAction,
  getPoiCompleteByIdAction,
})(WrappedPoiForm);

export default WrappedAddPoi;
